import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { LegacyEmailTemplateEntity } from './legacy-email-template.entity';

@Index('_fk__email_template__id', ['fkEmailTemplateId'], {})
@Index('_fk__file__id', ['fkFileId'], {})
@Entity('_email_template__file')
export class LegacyEmailTemplateFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', nullable: true, unsigned: true })
	public fkFileId!: number | null;

	@Column('int', {
		name: '_fk__email_template__id',
		nullable: true,
		unsigned: true,
	})
	public fkEmailTemplateId!: number | null;

	@ManyToOne(() => FileEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity | null;

	@ManyToOne(
		() => LegacyEmailTemplateEntity,
		(emailTemplate) => emailTemplate.emailTemplateFiles,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__email_template__id', referencedColumnName: 'id' }])
	public fkEmailTemplate!: LegacyEmailTemplateEntity | null;
}
